import React from 'react';

export const BootstrapContext = React.createContext({
  bootstrap4: false
});



// WEBPACK FOOTER //
// ./packages/react-bootstrap-table2/src/contexts/bootstrap.js